// Motion engine. Reads the theme setting from <html data-motion> (none | subtle | full) and the
// visitor's reduced-motion preference; when motion is allowed it marks <html> with .motion-on and
// reveals [data-reveal] elements and the children of [data-reveal-group] as they scroll into view.
// Only elements below the fold on load get a hidden start state, so nothing visible ever flashes,
// and without this script (or with motion off) every element simply stays visible.
(function () {
  'use strict';

  var root = document.documentElement;
  var level = root.dataset.motion || 'full';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var enabled = level !== 'none' && !reduce && 'IntersectionObserver' in window;

  window.Angar = window.Angar || {};
  // scan() is always callable so sections can re-scan new markup without checking the level first.
  window.Angar.motion = { level: level, enabled: enabled, scan: function () {} };
  if (!enabled) return;

  root.classList.add('motion-on');

  var STAGGER_MS = 60;
  var STAGGER_MAX = 8;

  // Drops the reveal classes once the entrance has played, so hover and other transforms on the
  // element work normally afterwards.
  function settle(el) {
    el.classList.remove('reveal', 'is-revealed');
    el.removeAttribute('data-reveal-stagger');
    el.style.removeProperty('--reveal-delay');
  }

  // Items that enter together are staggered in document order (capped), so a grid fills in as a
  // wave; an item that enters on its own reveals without delay.
  var observer = new IntersectionObserver(function (entries) {
    var entering = entries.filter(function (entry) { return entry.isIntersecting; }).map(function (entry) { return entry.target; });
    entering.sort(function (a, b) {
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    var step = 0;
    entering.forEach(function (el) {
      observer.unobserve(el);
      if (el.hasAttribute('data-reveal-stagger')) {
        el.style.setProperty('--reveal-delay', Math.min(step, STAGGER_MAX) * STAGGER_MS + 'ms');
        step += 1;
      }
      el.classList.add('is-revealed');
      // transitionend can be skipped (background tab, interrupted transition); a timer backs it up.
      var timer = setTimeout(function () { settle(el); }, 1600);
      el.addEventListener('transitionend', function done(event) {
        if (event.target !== el || event.propertyName !== 'opacity') return;
        el.removeEventListener('transitionend', done);
        clearTimeout(timer);
        settle(el);
      });
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });

  function prepare(el, staggered) {
    if (el.classList.contains('reveal') || el.getBoundingClientRect().top < window.innerHeight) return;
    if (staggered) el.setAttribute('data-reveal-stagger', '');
    el.classList.add('reveal');
    observer.observe(el);
  }

  function scanReveals(scope) {
    scope.querySelectorAll('[data-reveal]').forEach(function (el) { prepare(el, false); });
    scope.querySelectorAll('[data-reveal-group]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child) {
        // A nested group reveals its own items one by one, so it is not revealed as a block.
        if (child.tagName === 'SCRIPT' || child.tagName === 'STYLE' || child.hasAttribute('data-reveal-group')) return;
        prepare(child, true);
      });
    });
  }

  // Wraps the trailing "→" of arrow links in a span so it can nudge on hover.
  function wrapArrows(scope) {
    scope.querySelectorAll('.link-arrow, .contacto__maps').forEach(function (link) {
      if (link.querySelector('.arrow-nudge')) return;
      var node = link.lastChild;
      while (node && node.nodeType !== 3) node = node.previousSibling;
      if (!node) return;
      var match = node.nodeValue.match(/^([\s\S]*?)\s*→\s*$/);
      if (!match) return;
      node.nodeValue = match[1] + ' ';
      var arrow = document.createElement('span');
      arrow.className = 'arrow-nudge';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      node.parentNode.insertBefore(arrow, node.nextSibling);
    });
  }

  function scan(scope) {
    scanReveals(scope);
    wrapArrows(scope);
  }

  scan(document);
  window.Angar.motion.scan = scan;
})();
